/**
 * Created by Sergio on 25.07.2017.
 */

export const MUTATE_INVENTORY_TYPES = 'MUTATE_INVENTORY_TYPES';
export const MUTATE_RATES = 'MUTATE_RATES';
export const MUTATE_RATES_AND_AVAIL = 'MUTATE_RATES_AND_AVAIL';
export const MUTATE_INVENTORY_BLOCKS = 'MUTATE_INVENTORY_BLOCKS';
export const MUTATE_AGE_QUALIFIERS = 'MUTATE_AGE_QUALIFIERS';
export const MUTATE_INITIALIZED = 'MUTATE_INITIALIZED';
